export default __webpack_public_path__ + "static/media/br_rg_back.8e8dbae5.jpeg";